export const APP_TITLE = 'LiveBlog';
export const API_URL = import.meta.env.VITE_API_URL;
export const WIDGET_URL = import.meta.env.VITE_WIDGET_URL;
export const ENABLE_MOCKING = import.meta.env.VITE_ENABLE_MOCKING === 'true';
export const MOCK_DELAY = import.meta.env.VITE_MOCK_DELAY;
export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL!;
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY!;
export const UPLOAD_URL = import.meta.env.VITE_UPLOAD_URL;
